import styled from 'styled-components';

export const InputContainer = styled.div`
    height: 100px;   
    background-color: #FFFFFF;
    margin: 20px;
    border-radius: 10px;  
    display: flex;
    align-items: center;
    justify-content: flex-end; 

    input {
        width: 100%;
        height: 50px;
        background-color: #FFFFFF;
        border: 0;
        padding: 0 10px;
        text-align: end;
        font-size: 24px;
        font-family: 'Roboto';
        color: black;
    }
`